import { client } from "utils";

export const getConfigCiTestCasesStatusesRequest = () => client.get("config-ci-test-case-task-statuses");
